export const baseUrl =
  "https://auth.bexio.com/realms/bexio/protocol/openid-connect/auth";

export const bexioApp = {
  id: 96,
  name: "bexio",
  label: "bexio",
  areaBlacklist: ["productSelection", "journal", "migration"],
  disableAdvancedSettings: true,
  useOAuth: true,
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/bexio.png",
  environmentVariables: {
    // bexio only offers the authorization code grant, so the wizard sends the
    // user through the consent screen instead of asking for credentials.
    oauth: {
      client_id: process.env?.VUE_APP_BEXIO_APP_CLIENT_ID,
      redirect_uri: process.env?.VUE_APP_BEXIO_APP_REDIRECT_URL,
      response_type: process.env?.VUE_APP_BEXIO_APP_RESPONSE_TYPE,
      scope: process.env?.VUE_APP_BEXIO_APP_SCOPE
    },
    presetId: process.env?.VUE_APP_SCM_APP_BEXIO_PRESET_ID
  }
};
